import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-secondary-800 via-primary-800 to-warm-900 text-white mt-20">
      {/* Decorative top border */}
      <div className="h-2 bg-gradient-to-r from-primary-400 via-warm-400 to-accent-400 opacity-70"></div>
      
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-br from-warm-500 to-primary-600 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl font-sanskrit">स</span>
              </div>
              <div>
                <h3 className="text-2xl font-elegant font-bold">SoundX724</h3>
                <p className="text-warm-200 text-sm font-sanskrit">यत्र सङ्गीतं तत्र आत्मनः|</p>
              </div>
            </div>
            <p className="text-warm-200 text-sm leading-relaxed">
              Celebrating the rich heritage of Indian classical music through immersive events, 
              comprehensive education, and vibrant community engagement.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-xl mb-6 text-warm-200">Quick Links</h4>
            <ul className="space-y-3 text-base">
              <li><Link to="/" className="text-warm-300 hover:text-warm-100 transition-all duration-300 hover:translate-x-1 block" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/events" className="text-warm-300 hover:text-warm-100 transition-all duration-300 hover:translate-x-1 block" onClick={scrollToTop}>Events</Link></li>
              <li><Link to="/team" className="text-warm-300 hover:text-warm-100 transition-all duration-300 hover:translate-x-1 block" onClick={scrollToTop}>Team</Link></li>
              <li><Link to="/about" className="text-warm-300 hover:text-warm-100 transition-all duration-300 hover:translate-x-1 block" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/privacy" className="text-warm-300 hover:text-warm-100 transition-all duration-300 hover:translate-x-1 block" onClick={scrollToTop}>Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Music Categories */}
          <div>
            <h4 className="font-bold text-xl mb-6 text-warm-200">Music Categories</h4>
            <ul className="space-y-3 text-base text-warm-300">
              <li className="hover:text-warm-100 transition-colors cursor-pointer">Hindustani Classical</li>
              <li className="hover:text-warm-100 transition-colors cursor-pointer">Instrumental</li>
              <li className="hover:text-warm-100 transition-colors cursor-pointer">Vocal Recitals</li>
              <li className="hover:text-warm-100 transition-colors cursor-pointer">Fusion & Contemporary</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-xl mb-6 text-warm-200">Chat or Collaborate With Us</h4>
            <div className="space-y-3 text-base text-warm-300">
              <p className="flex items-center space-x-2">
                <span>📧</span>
                <span><a href="mailto:soundx724@gmail.com">soundx724@gmail.com</a></span>
              </p>
              <p className="flex items-center space-x-2">
                <span><img src="/img/core-img/ext-logos/icons8-whatsapp-48.png" alt="WhatsApp" style={{ width: '50%', height: '50%' }}></img></span>
                <span style={{ fontSize: '14px' }}><a href="https://wa.me/16477417277" target="_blank" rel="noopener noreferrer">
                  +1-647-741-7277</a></span>
                <span style={{ fontSize: '14px' }}> | </span>
                <span style={{ fontSize: '14px' }}><a href="https://wa.me/16476194645" target="_blank" rel="noopener noreferrer">
                  +1-647-619-4645</a></span>
              </p>
              <p className="flex items-center space-x-2">
                <span>📍</span>
                <span>Milton, Canada</span>
              </p>
            </div>
            <div className="flex space-x-4 mt-4">
              <a href="https://www.facebook.com/profile.php?id=61562502383118" target="_blank" rel="noopener noreferrer" className="transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="#1877F2" d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.326 24h11.495v-9.294H9.691v-3.622h3.13V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.104C23.405 24 24 23.408 24 22.674V1.326C24 .592 23.405 0 22.675 0" />
                </svg>
              </a>
              <a href="https://www.instagram.com/soundx724/" target="_blank" rel="noopener noreferrer" className="transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
                  <defs>
                    <linearGradient id="igGradFooter" x1="0" x2="1" y1="0" y2="1">
                      <stop offset="0%" stopColor="#feda75" />
                      <stop offset="50%" stopColor="#f58529" />
                      <stop offset="100%" stopColor="#d6249f" />
                    </linearGradient>
                  </defs>
                  <rect x="0" y="0" width="24" height="24" rx="5" fill="url(#igGradFooter)" />
                  <path fill="#fff" d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm4.6-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                </svg>
              </a>
              <a href="https://www.youtube.com/@soundx724" target="_blank" rel="noopener noreferrer" className="transition-colors">
                <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="#FF0000" d="M23.498 6.186a2.994 2.994 0 0 0-2.112-2.112C19.671 3.75 12 3.75 12 3.75s-7.671 0-9.386.324a2.994 2.994 0 0 0-2.112 2.112C.75 7.901.75 12 .75 12s0 4.099.324 5.814a2.994 2.994 0 0 0 2.112 2.112C4.329 20.25 12 20.25 12 20.25s7.671 0 9.386-.324a2.994 2.994 0 0 0 2.112-2.112c.324-1.715.324-5.814.324-5.814s0-4.099-.324-5.814z" />
                  <path fill="#fff" d="M9.75 15.375v-6.75l6.75 3.375-6.75 3.375z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-warm-600/30 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row md:items-center md:space-x-6">
              <p className="text-warm-400 text-sm">
                © 2026 SoundX724 Music Collective. All rights reserved.<br />
                SoundX724 and the SoundX724 logo are trademarks of SoundX724 Music Collective.<br />
                All other trademarks, service marks, and logos are the property of their respective owners.<br />
                Unauthorized use is strictly prohibited.
              </p>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;